<template>
  <div id="popup">
    <div class="colored-top overlay" :style="styles">
      <modal-actions :back-action="backAction" :close-action="closeAction" :dark-text="darkText" />
      <div class="overlay-content">
        <slot></slot>
      </div>

      <template v-if="hasFooterSlot">
        <separator/>
        <div class="footer">
          <slot name="footer"></slot>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import Colors from '../../scss/riseup-js-colors.module.scss';
import ModalActions from '../ModalActions.vue';
import Separator from '../Separator.vue';

export default {
  name: 'OverlayColoredPopup',
  components: {
    ModalActions,
    Separator,
  },
  props: {
    closeAction: {
      type: Function,
      require: false,
      default: null,
    },
    backAction: {
      type: Function,
      require: false,
      default: null,
    },
    darkText: {
      type: Boolean,
      require: false,
    },
    overlayHeight: {
      type: Number,
      default: 300,
    },
    backgroundColor: {
      type: String,
      require: false,
    },
  },
  data() {
    return {
      riseupBlack: Colors.riseupBlack,
      riseupWhite: Colors.riseupWhite,
    };
  },
  computed: {
    hasFooterSlot() {
      return !!this.$slots.footer;
    },
    styles() {
      return {
        '--overlay-height': `${this.overlayHeight}px`,
        '--under-color': this.backgroundColor ?? this.riseupWhite,
      };
    },
  },
  methods: {
    onActionClick() {
      if (this.backAction) {
        this.backAction();
      } else if (this.closeAction) {
        this.closeAction();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "colored-popup";

#popup {

  .colored-top.overlay {
    border-radius: $popup-border-radius;
    padding: 40px 0 0 0;
    .overlay-content {
      padding: 0 24px;
    }
    .footer {
      background: var(--under-color);
    }
  }
}
</style>
